import {gql} from "apollo-boost";

export const CIBER_SCHEMA = gql`
    type Query {


        #Information of SAP Colsubsidio
        affiliation (
            #institution id afiliation
            institutionId: Int!
            #Schedule id afiliation
            scheduleId: Int!
        ) : Afiliate

        #Information of SAP Colsubsidio BAC
        bacAffiliation : Afiliate

        #authentication based of Colsubsidio SSO
        ssoLogin(
            #serial device id
            deviceId: String!
        ) : String

        #List of Degrees available Colsubsidio
        degrees(
            #institution id beneficiary
            institutionId: Int!
            #Schedule id beneficiary
            scheduleId: Int!
        ): [Degree]

        employeeFunCol(
            documentType:Int!
            documentNumber:String!
        ): Employee

        degreesFunCol: [Degree]

        degreesBac: [Degree]

        #get institutions Colsubsidio
        institutions: [Institution]

        #List of documentTypes
        documentTypes : [DocumentType]

    }

    type Mutation {
        #Save inscription information
        saveInscription(
            #Data inscription type
            dataInscription: DataInscription!
        ): Status

        saveInscriptionFunCol(
            #Data inscription type
            dataInscription: DataInscriptionFunCol!
        ): Status

        saveInscriptionBac(
            #Data inscription type
            dataInscription: DataInscriptionBAC!
        ): Status

        saveInscriptionBacNoAffiliate(
            #Data inscription type
            dataInscription: DataInscriptionBACNoAffi!
        ): Status


        #authentication based of documentType & documentNumber
        externalAuth(
            #document Type
            documentType: Int!
            #document number
            documentNumber: String!
            #password
            password: String!
            #serial device id
            deviceId: String!
        ): Login

    }

    #Data inscription type : contains data of inscription
    type DocumentType {
        #Id type
        id: Int!
        #Document description
        description: String!
    }
    #Data inscription type : contains data of inscription
    input DataInscription {
        #affiliation document type
        affiliateDocType: Int!
        #affiliation document
        affiliateDocument: String!
        #beneficiary document type
        beneficiaryDocType: Int!
        #beneficiary document type
        beneficiaryDocument: String!
        #beneficiary institution
        institutionId: Int!
        #beneficiary scheduled
        scheduleId: Int!
        #beneficiary level
        levelId: Int
        #beneficiary program
        programId: Int
        #beneficiary degree
        degreeId: Int
        #birthdate beneficiary/inconsistence
        birthDate: String!
        #Beneficiary name
        beneficiaryName: String!
        #Beneficiary last name
        beneficiaryLastName: String!
        #Affiliate name
        affiliateName: String!
        #Affiliate last name
        affiliateLastName: String!
        #serial device id
        deviceId: String!
    }

    #Data inscription type for BAC (Bachillerato de adultos Colsubsidio): contains data of inscription
    input DataInscriptionBACNoAffi {
        #affiliation document type
        affiliateDocType: Int!
        #affiliation document
        affiliateDocument: String!
        #beneficiary document type
        beneficiaryDocType: Int!
        #beneficiary document type
        beneficiaryDocument: String!
        #beneficiary level
        levelId: Int
        #beneficiary program
        programId: Int
        #beneficiary degree
        degreeId: Int
        #birthdate beneficiary/inconsistence
        birthDate: String!
        #Beneficiary name
        beneficiaryName: String!
        #Beneficiary last name
        beneficiaryLastName: String!
        #Affiliate name
        affiliateName: String!
        #Affiliate last name
        affiliateLastName: String!
        #serial device id
        deviceId: String!
        #Contact person name
        contact: String
        #Contact phone
        phoneContact: String
    }

    #Data inscription type for BAC No Affiliate (Bachillerato de adultos Colsubsidio): contains data of inscription
    input DataInscriptionBAC {
        #beneficiary document type
        beneficiaryDocType: Int!
        #beneficiary document type
        beneficiaryDocument: String!
        #beneficiary level
        levelId: Int
        #beneficiary program
        programId: Int
        #beneficiary degree
        degreeId: Int
        #birthdate beneficiary/inconsistence
        birthDate: String!
        #Beneficiary name
        beneficiaryName: String!
        #Beneficiary last name
        beneficiaryLastName: String!
        #Affiliate name
        affiliateName: String!
        #Affiliate last name
        affiliateLastName: String!
        #serial device id
        deviceId: String!
        #Contact person name
        contact: String
        #Contact phone
        phoneContact: String
    }

    #Data inscription type for Fundacion Colombia: contains data of inscription
    input DataInscriptionFunCol {
        #affiliation document type
        affiliateDocType: Int!
        #affiliation document
        affiliateDocument: String!
        #beneficiary document type
        beneficiaryDocType: Int!
        #beneficiary document type
        beneficiaryDocument: String!
        #beneficiary level
        levelId: Int
        #beneficiary program
        programId: Int
        #beneficiary degree
        degreeId: Int
        #birthdate beneficiary/inconsistence
        birthDate: String!
        #Beneficiary name
        beneficiaryName: String!
        #Beneficiary last name
        beneficiaryLastName: String!
        #serial device id
        deviceId: String!
    }

    # Status Object: return success status or warning of transaction
    type Status{
        #status code
        statusCode: String!
        #status message
        message: String
        #redirect url
        redirectUrl: String
    }

    # Login Object: return success login
    type Login{
        #user id
        id: ID
        #name
        name: String
        #last name
        lastName: String
        #return url
        returnUrl: String
    }

    # Afiliate Object:  return success affiliate data
    type Afiliate{
        #document Type
        documentType: String
        #document number
        documentNumber: String
        #name
        name: String
        #last name
        lastName: String
        #birth date
        birthDate: String
        #affiliation status
        status: String
        #beneficiary list data
        beneficiaries: [Beneficiary]
    }

    # Beneficiary Object: return success beneficiary data
    type Beneficiary {
        #document Type
        documentType: String
        #document number
        documentNumber: String
        #name
        name: String
        #last name
        lastName: String
        #birth date
        birthDate: String
        #age
        age: Int
        #affiliation status
        status: String
    }

    # Beneficiary Object: return success beneficiary data
    type Employee {
        institutionId:Int
        scheduleId :Int
        documentType:Int
        documentNumber:String
        name:String
        lastName:String
    }

    # Institution Object: return institution data
    type Institution {
        #institution id (ref: institution)
        institutionId: Int!
        #Schedule id (ref: jornada)
        scheduleId: Int!
        #Institution name
        name: String
    }

    type Degree {
        #level id
        levelId: Int!
        #program id
        programId: Int!
        #degree id
        degreeId: Int!
        #Desciption degree
        description: String
    }


`
